export const capitalizeFirstLetter = (str: string): string => {
  if (!str[0]) {
    return "";
  }

  return str[0].toUpperCase() + str.slice(1);
};
